import { css as t, styled as r } from "styled-components";
import { SmartLink as i } from "../SmartLink/index.js";
import { BodyHeavy as e } from "../../styles/typography/index.js";
import { MediaQuery as a } from "../../styles/variables.js";
import { Theme as o } from "../../styles/themes/index.js";
import { TextSkeleton as l } from "../TextSkeleton/index.js";
const d = t`
  display: inline-flex;
  align-items: center;
  border-radius: 12px;
  padding: 12px 16px;
  border: 1px solid rgb(${o.colors.Bravo});
  color: rgb(${o.colors.Alpha});
  background: rgb(${o.colors.Juliet});
  overflow: hidden;
`, h = r.span`
  white-space: nowrap;
  ${e}
  @media ${a.SCREEN_MD_UP} {
    ${e}
  }
`, x = r(i)`
  ${d}
  text-decoration: none;

  &:hover {
    color: rgb(${o.colors.Alpha});
  }
`, f = r.figure`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
`, S = r(l)`
  width: 32px;
  height: 32px;
  border-radius: 4px;
`;
export {
  S as LogoSkeleton,
  f as LogoWrapper,
  x as SmallStoreCardContainer,
  d as SmallStoreCardContainerStyles,
  h as SmallStoreCardText
};
